import $ from 'jquery';
import mapboxgl from 'mapbox-gl';
import { scrollToElement } from '../lib/utilities';
import { compact } from 'lodash';
import {
  initialBounds,
  maxZoom,
  padding,
  popupOffset
} from '../config/mapConfig';
import { MAPBOX_API_KEY } from '../config';

mapboxgl.accessToken = MAPBOX_API_KEY;

const createStoreFromResults = (results) => {
  const store = {
    type: 'FeatureCollection',
    features: []
  };
  results.forEach((result) => {
    store.features.push({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [result.post_location.lng, result.post_location.lat]
      },
      properties: result
    });
  });
  return store;
};

const generateBounds = (results) => {
  if (!results.length) {
    return null;
  }

  const bounds = new mapboxgl.LngLatBounds();
  results.forEach((result) => {
    bounds.extend([result.post_location.lng, result.post_location.lat]);
  });

  return bounds;
};

const clearPopups = () => {
  $('.mapboxgl-popup').each((index, popup) => {
    popup.remove();
  });
};

const mapWidget = (config) => {
  const container = $(config.container);
  let map;

  return {
    init: (options) => {
      container.html('<div id="ais-map" class="ais-map-container"></div>');
      map = new mapboxgl.Map({
        bounds: initialBounds,
        container: 'ais-map',
        scrollZoom: false,
        style: 'mapbox://styles/propanecouncil/cjoovbm9c46f42qntb8o5itlq'
      });
      map.addControl(
        new mapboxgl.NavigationControl({ showCompass: false }),
        'top-right'
      );
      map.on('click', (event) => {
        // Query all the rendered points in the view
        const features = map.queryRenderedFeatures(event.point, {
          layers: ['markers']
        });
        if (features.length) {
          const clickedPoint = features[0];
          let offset;

          if (map.getZoom() < 2) {
            offset = 16;
          } else if (map.getZoom() < 3) {
            offset = 8;
          } else if (map.getZoom() < 4) {
            offset = 6;
          } else if (map.getZoom() < 5) {
            offset = 3.3;
          } else if (map.getZoom() < 6) {
            offset = 1.8;
          } else if (map.getZoom() < 7) {
            offset = 0.85;
          } else if (map.getZoom() < 8) {
            offset = 0.35;
          } else {
            offset = 0;
          }

          // Fly to marker
          map.flyTo({
            center: [
              clickedPoint.geometry.coordinates[0],
              clickedPoint.geometry.coordinates[1] + offset
            ],
            zoom: map.getZoom()
          });

          // Remove existing popups
          clearPopups();

          // Create popup
          let description = '';
          if (clickedPoint.properties.post_type === 'event') {
            description = `
              <div class="map__result-address">
                ${compact([
                  clickedPoint.properties.post_formatted_date,
                  clickedPoint.properties.post_formatted_time,
                  clickedPoint.properties.post_formatted_address
                ]).join('<br />')}
              </div>
            `;
          } else {
            description = `
              <div class="map__result-description">
                ${clickedPoint.properties.post_excerpt}
              </div>
            `;
          }
          let image = '';
          if (clickedPoint.properties.post_image) {
            image = `
              <img class="map__result-image" src="${clickedPoint.properties.post_image}" />
            `;
          }
          const popupHtml = `
            <div class="map__popup${image ? ' map__popup--has-image' : ''}">
              ${image}
              <h3 class="map__result-title">
                ${clickedPoint.properties.post_title}
              </h3>
              ${description}
              <ul class="map__result-actions">
                <li>
                  <a href="${
                    clickedPoint.properties.permalink
                  }" class="btn btn--red btn--link btn--cloak btn--has-arrow module-hover-root">
                    <span class="btn__content">
                        <span class="btn__text">Learn More</span>
                        <span class="btn__arrow arrow"></span>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          `;
          new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
            offset: popupOffset
          })
            .setLngLat(clickedPoint.geometry.coordinates)
            .setHTML(popupHtml)
            .addTo(map);
        }
      });
    },
    render: (options) => {
      // Remove existing popups
      clearPopups();

      if (!map.loaded()) {
        map.on('load', () => {
          // Add markers
          map.addSource('locations', {
            type: 'geojson',
            data: createStoreFromResults(options.results.hits)
          });
          map.addLayer({
            id: 'markers',
            type: 'symbol',
            source: 'locations',
            layout: {
              'icon-image': 'marker-15',
              'icon-allow-overlap': true
            }
          });

          // Fit bounds
          map.fitBounds(generateBounds(options.results.hits), {
            maxZoom,
            padding
          });
        });
      } else {
        // Scroll to map
        scrollToElement(container);

        // Reset map
        map.fitBounds(initialBounds, { padding });

        // Add markers
        map
          .getSource('locations')
          .setData(createStoreFromResults(options.results.hits));

        // Fit bounds
        map.fitBounds(generateBounds(options.results.hits), {
          maxZoom,
          padding
        });
      }
    }
  };
};

export default mapWidget;
